import { SerializedDevice } from "modules/deviceInfo";

export function toSerialized(
  device: MediaDeviceInfo | SerializedDevice,
): SerializedDevice {
  return {
    deviceId: device.deviceId,
    label: device.label,
  };
}
